import React from "react"

const ImpactSection = ({ title, description, items }) => (
  <div className="container py-6 px-5 is-flex is-flex-direction-column text-dark-blue has-text-left has-text-centered-desktop has-text-centered-tablet">
    <h2 className="is-size-2-desktop is-size-3-mobile is-size-3-tablet has-text-weight-semibold has-line-height-custom">
      {title}
    </h2>

    <div className="columns is-centered">
      <div className="column is-size-5-desktop mt-4 impact-description">
        {description}
      </div>
    </div>

    <div className="impact-grid">
      {items.map(({ title, src }) => (
        <div key={title} className="impact-item has-text-centered mt-5">
          <div className="mb-3">
            <img src={src} alt={title} />
          </div>
          <p className="is-size-5-desktop is-size-6-mobile is-size-6-tablet has-text-weight-semibold text-dark-blue has-line-height-2">
            {title}
          </p>
        </div>
      ))}
    </div>
  </div>
)

export default ImpactSection
